import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiUsers, FiMessageSquare, FiActivity, FiClock } = FiIcons;

export default function AnalyticsSummaryCards({ onlineCount, totalMessages, messages, users }) {
  // Calcular tasa de interacción (mensajes promedio por usuario activo)
  const activeChatters = users.length;
  const engagementRate = activeChatters > 0 
    ? ((totalMessages / activeChatters)).toFixed(1) 
    : '0.0';

  // Calcular velocidad del chat (mensajes en los últimos 2 minutos)
  const twoMinutesAgo = new Date(Date.now() - 2 * 60 * 1000);
  const recentMessages = messages.filter(m => new Date(m.created_at) > twoMinutesAgo).length;
  const messagesPerMinute = (recentMessages / 2).toFixed(1);

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {/* Espectadores en Tiempo Real */}
      <div className="rounded-2xl border border-white/10 bg-[#111] p-4 sm:p-5 relative overflow-hidden group">
        <div className="absolute top-0 right-0 h-1 w-24 bg-red-600 rounded-bl-full opacity-60" />
        <div className="flex items-center justify-between">
          <span className="text-xs font-medium text-gray-400 sm:text-sm">En Vivo Ahora</span>
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-600/10 text-red-500">
            <SafeIcon icon={FiUsers} size={18} />
          </span>
        </div>
        <div className="mt-4 flex items-baseline gap-2">
          <span className="text-2xl font-bold tracking-tight text-white sm:text-3xl">{onlineCount}</span>
          <span className="flex items-center gap-1 text-[10px] font-semibold text-green-400 animate-pulse">
            <span className="h-1.5 w-1.5 rounded-full bg-green-400" />
            activo
          </span>
        </div>
      </div>

      {/* Mensajes Totales */}
      <div className="rounded-2xl border border-white/10 bg-[#111] p-4 sm:p-5 relative overflow-hidden group">
        <div className="flex items-center justify-between">
          <span className="text-xs font-medium text-gray-400 sm:text-sm">Mensajes Totales</span>
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-500/10 text-blue-400">
            <SafeIcon icon={FiMessageSquare} size={18} />
          </span>
        </div>
        <div className="mt-4">
          <span className="text-2xl font-bold tracking-tight text-white sm:text-3xl">{totalMessages}</span>
          <p className="text-[10px] text-gray-500 mt-1">Historial del evento</p>
        </div>
      </div>

      {/* Ratio de Engagement */}
      <div className="rounded-2xl border border-white/10 bg-[#111] p-4 sm:p-5 relative overflow-hidden group">
        <div className="flex items-center justify-between">
          <span className="text-xs font-medium text-gray-400 sm:text-sm">Tasa de Interacción</span>
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-yellow-500/10 text-yellow-500">
            <SafeIcon icon={FiActivity} size={18} />
          </span>
        </div>
        <div className="mt-4">
          <span className="text-2xl font-bold tracking-tight text-white sm:text-3xl">{engagementRate}</span>
          <p className="text-[10px] text-gray-500 mt-1">Mensajes/Espectador</p>
        </div>
      </div>

      {/* Velocidad de Chat */}
      <div className="rounded-2xl border border-white/10 bg-[#111] p-4 sm:p-5 relative overflow-hidden group">
        <div className="flex items-center justify-between">
          <span className="text-xs font-medium text-gray-400 sm:text-sm">Velocidad de Chat</span>
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-purple-500/10 text-purple-400">
            <SafeIcon icon={FiClock} size={18} />
          </span>
        </div>
        <div className="mt-4">
          <span className="text-2xl font-bold tracking-tight text-white sm:text-3xl">{messagesPerMinute}</span>
          <p className="text-[10px] text-gray-500 mt-1">Mensajes por minuto</p>
        </div>
      </div>
    </div>
  );
}